var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "container row content-padding" }, [
    _c(
      "div",
      { staticClass: "col-md-3 sidenav-column" },
      [
        _c("ul", { staticClass: "list-unstyled" }, [
          _c(
            "li",
            [
              _c(
                "router-link",
                {
                  staticClass: "sidenav-item",
                  attrs: {
                    to: "/my-reservations",
                    "active-class": "sidenav-active"
                  }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("message.menu.my_reservations")) +
                      "\n        "
                  )
                ]
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "router-link",
          {
            staticClass: "button button-large -cyan",
            attrs: { to: "/booking/start" }
          },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("message.my_reservations.new_booking")) +
                "\n    "
            )
          ]
        ),
        _vm._v(" "),
        _c("p", [_vm._v(" ")])
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-md-9 content-column" },
      [
        _c("h3", [_vm._v(_vm._s(_vm.$t("message.menu.my_reservations")))]),
        _vm._v(" "),
        _c(
          "transition",
          { attrs: { name: "slide", mode: "out-in" } },
          [_c("my-orders")],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b7c1851", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b7c1851","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/Index.vue
// module id = 1673
// module chunks = 0